export default __webpack_public_path__ + "static/media/art2.ac4bc63c.jpg";